import PubSub from "pubsub-js";
import q from "../lib/query";
import Navigation from "../components/Navigation.vue";
import Vue from "vue";

// Lazyload
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes";

import SideMenu from "../lib/SideMenu";
import { setDocumentElementCSSVar } from "../lib/header-height-css-var";

// Require vendor packages that are implicitly included, e.g. via jQuery plugins.
require("slick-carousel");

// General window events. Events fired via window.PubSub.
require("../lib/window-scroll-events");
require("../lib/keyboard-events");
require("../lib/announcement-bar");
require("../lib/pop-up");

window.gm = null;
window.PubSub = PubSub;

function stickyHeader() {
  let header = q(".sticky-header");

  // Get our current top position.
  window.PubSub.subscribe("window:scroll", function(name, { top }) {
    let action = top > 200 ? "add" : "remove";

    header.classList[action]("sticky-header-in");
  });
}

function initSliders() {
  $(".slick-slider").each(function() {
    let $this = $(this);
    // These args can be overridden by passing a `data-slick` option in the
    // .slick-slider element in a JSON format.
    let args = {
      infinite: true,
      adaptiveHeight: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true
    };

    $this.slick(args);

    // $this.on('swipe', event => {
    //   event.preventDefault();
    // });
  });
}

function toggles() {
  $("[data-toggle]").on("click", function(e) {
    e.preventDefault();

    $($(this).data("target")).slideToggle(200);
  });
}

function anchorLinks() {
  $(document).on("click", '[href^="#"]', function(e) {
    if (this.href.length > 1) {
      return true;
    }

    let $this = $(this);
    let $target = $($this.attr("href"));

    if ($target.length > 0) {
      e.preventDefault();

      $("html, body").animate({ scrollTop: $target.offset().top }, 250);

      return;
    }
  });
}

function menu() {
  let menu = new SideMenu();

  $(document).on("click", ".what-we-sell__button", function() {
    menu.toggle();
  });

  window.PubSub.subscribe("overlay:click", function() {
    menu.close();
  });

  $(document).on("keydown", e => {
    if (menu.isOpen() && e.which == 27) {
      menu.close();
    }
  });

  $('[data-target="#mobile-navigation"]').on("click", function() {
    document.body.classList.toggle("mobile-nav-open");
  });
}

function checkMobile() {
  return window.matchMedia("(max-width: 1049px)").matches;
}

function uiOverlayTransition(classBase = "overlay", show = true) {
  let action = show ? "in" : "out";
  let b = document.body.classList;

  b.add(`${classBase}-${action}-active`);

  setTimeout(() => {
    b.add(`${classBase}-${action}-to`);
  }, 1);

  setTimeout(() => {
    b.remove(`${classBase}-${action}-active`);
    b.remove(`${classBase}-${action}-to`);

    window.PubSub.publish("transition:end", { base: classBase, show });
  }, 300);
}

function overlay() {
  let b = document.body.classList;

  window.PubSub.subscribe("overlay:show", function() {
    uiOverlayTransition("overlay", true);
  });

  window.PubSub.subscribe("overlay:hide", function() {
    uiOverlayTransition("overlay", false);
  });

  window.PubSub.subscribe("transition:end", function(name, { base, show }) {
    if (base === "overlay") {
      if (show === true) {
        b.add("overlay-active");
      } else {
        b.remove("overlay-active");
      }
    }
  });
}

function mobileMenu() {
  let isMobile = checkMobile();

  $(document).on(
    "click",
    '#mobile-navigation .menu-item a[href="#"], .menu-item-subnav-toggle',
    function(e) {
      e.preventDefault();

      $(this)
        .parent()
        .parent()
        .find(".sub-menu__wrapper")
        .stop()
        .toggleClass('block');
    }
  );

  window.PubSub.subscribe("locations:show", function() {
    $("#mobile-navigation").slideUp();

    document.body.classList.remove("mobile-nav-open");
  });

  window.PubSub.subscribe("window:resize", function() {
    let current = checkMobile();

    if (isMobile != current) {
      isMobile = current;

      $(".sub-menu").hide();
    }
  });
}

function locations() {
  let $sidebar = $(".locations-sidebar");
  let locationsOpen = false;
  let locationsLink = $(".menu-locations-hours a");

  $(document).on("click", ".menu-locations-hours a", function(e) {
    e.preventDefault();

    locationsOpen = !locationsOpen;

    window.PubSub.publish(locationsOpen ? "locations:show" : "locations:hide");
  });

  $(document).on("click", '[href="#locations-sidebar"]', function() {
    window.PubSub.publish("locations:show");
  });

  window.PubSub.subscribe("locations:show", function() {
    locationsLink.addClass("active");
  });

  window.PubSub.subscribe("overlay:click", function() {
    locationsLink.removeClass("active");
  });

  window.PubSub.subscribe("locations:hide", function() {
    locationsLink.removeClass("active");
  });

  window.PubSub.subscribe("locations:show", function() {
    $sidebar.show();

    setTimeout(() => {
      $sidebar.addClass("locations-sidebar--in");

      locationsOpen = true;
    }, 10);
  });

  window.PubSub.subscribe("locations:hide", function() {
    $sidebar.removeClass("locations-sidebar--in");

    setTimeout(() => {
      $sidebar.hide();

      locationsOpen = false;
    }, 225);
  });
}

function vue() {
  const app = new Vue(Navigation);

  app.$mount("#navigation");
}

// setTimeout pointer so we can loop and confirm that our google maps are loaded
let timer;

function loadMaps() {
  let script = document.createElement("script");

  script.src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyDKDvQoWUOznwboLUfRQn18uMuPFnrDUK0&libraries=places&callback=Function.prototype";
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);

  checkMapsLoaded();
}

function checkMapsLoaded() {
  timer = setTimeout(function() {
    if (window.google && window.google.maps) {
      window.PubSub.publish("maps:loaded");

      window.gm = window.google.maps;

      clearTimeout(timer);
    } else {
      checkMapsLoaded();
    }
  }, 100);
}

function gformFilters() {
  jQuery(document).on("gform_confirmation_loaded", function(event, formId) {
    setTimeout(function() {
      $("html, body").animate(
        {
          scrollTop:
            $(`#gform_confirmation_message_${formId}`).offset().top - 150
        },
        300
      );
    }, 25);
  });
}

function locationBlocks() {
  let $pointers = $(".location-map .pointer");

  $(document).on("mouseenter", "a.location-block", function() {
    let $this = $(this);
    let slug = $this.data("location-slug");
    let $pointer = $(`#pointer-${slug}`);

    if ($pointer.length > 0) {
      $pointers.not($pointer).addClass("pointer--fade");

      $pointer.addClass("pointer--scale");
    }
  });

  $(document).on("mouseleave", "a.location-block", function() {
    $pointers.removeClass("pointer--fade pointer--scale");
  });
}

function accordions() {
  const accordionButtons = document.querySelectorAll(".accordion__button");
  const accordionSections = document.querySelectorAll(".accordion__row-body");

  accordionSections.forEach(section => {
    section.setAttribute("aria-hidden", true);
    section.classList.remove("open");
  });

  accordionButtons.forEach(button => {
    button.setAttribute("aria-expanded", false);

    const number = button
      .getAttribute("id")
      .split("-")
      .pop();
    const associatedSection = document.getElementById(
      `accordion-body-${number}`
    );

    button.addEventListener("click", () => {
      button.classList.toggle("expanded");
      associatedSection.classList.toggle("open");

      if (button.classList.contains("expanded")) {
        button.setAttribute("aria-expanded", true);
        associatedSection.setAttribute("aria-hidden", false);
        return;
      }

      button.setAttribute("aria-expanded", false);
      associatedSection.setAttribute("aria-hidden", true);
    });
  });
}

function headerRootStyles() {
  let $header = $(".sticky-header");

  function setCSSVar() {
    setDocumentElementCSSVar($header.outerHeight(), "--header-height");
  }

  setCSSVar();

  window.PubSub.subscribe("announcement-bar-loaded", setCSSVar);
  window.PubSub.subscribe("announcement-bar-closed", setCSSVar);
  window.PubSub.subscribe("window:resize", setCSSVar);
}

export default {
  init() {
    headerRootStyles();
    anchorLinks();
    locationBlocks();
    stickyHeader();
    initSliders();
    toggles();
    menu();
    mobileMenu();
    locations();
    overlay();
    vue();
    loadMaps();
    gformFilters();
    accordions();
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js